import React from 'react';
import PropTypes from 'prop-types';

import { Container, Video } from './styles';

function AiEndingVideo({ data, isBuilder }) {
  return (
    <Container isBuilder={isBuilder}>
      <Video
        src={data.video}
        autoPlay
        loop
        muted
        playsInline
      />
    </Container>
  );
}

AiEndingVideo.propTypes = {
  data: PropTypes.shape({
    video: PropTypes.string,
    prompt: PropTypes.string,
    promptId: PropTypes.string,
  }),
  isBuilder: PropTypes.bool,
};

AiEndingVideo.defaultProps = {
  data: {
    video:
      'https://overlayon.s3.eu-west-3.amazonaws.com/ai-ending-video-default.mp4',
    prompt:
      'A cinematic farewell scene with golden hour lighting, featuring "Thanks for Watching" in elegant flowing text, surrounded by floating particles and gentle light rays.',
    promptId: 'cinematic-ending',
  },
  isBuilder: false,
};

export default AiEndingVideo;